export { default } from './WellnessPlan';
